module.exports = __webpack_public_path__ + "img/team_dashboard.f3c2361d.svg";